import { queryOptions } from "@tanstack/react-query";
import type { Branch, Entitlements, Permission, PlanId, TenantSettings } from "@zeeta/shared";
import { api } from "@/lib/api";

export interface TenantOverview {
  tenantId: string;
  settings: TenantSettings;
  branches: Branch[];
  membership: { role: string; permissions: Permission[]; branchScope: string[] | null };
  plan: {
    id: PlanId;
    purchased: PlanId;
    status: "active" | "grace" | "lapsed";
    currentPeriodEnd: number | null;
    graceEndsAt: number | null;
    /** Limits and features after platform and per-business changes. */
    entitlements?: Entitlements;
  };
  /** Set when Zeetabyte staff are looking in on a support visit. */
  support?: { id: string; mode: "read" | "write" | "full"; expiresAt: number } | null;
  maintenance?: {
    readOnly: true;
    global: boolean;
    message: { en: string; bn: string } | null;
  } | null;
  announcements?: {
    id: string;
    title: { en: string; bn: string };
    body: { en: string; bn: string };
    severity: "info" | "warning" | "critical";
    dismissible: boolean;
  }[];
}

export const overviewQuery = (tenantId: string) =>
  queryOptions({
    queryKey: ["tenant", tenantId, "overview"],
    queryFn: () => api.get<TenantOverview>(`/t/${tenantId}/overview`),
    staleTime: 30_000,
  });
